import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Badge, Logo, Navbar } from '@tempmee/react';
import { routes } from '~/routes';
import { NAVBAR_HEIGHT } from '~/constants/layout';
import { logOut, showMessage } from '../../actions';
import history from '../../browserHistory';
import {
  fireMenuBarAccountClicked,
  fireMenuBarHelpClicked,
  fireMenuBarInboxClicked,
} from '~/posthogs/events';
import { useInboxCount } from '../Inbox/hooks/useInboxCount';

interface ITopNavBarProps {
  hasOfficeSelected?: boolean;
}

export default function TopNavBar({ hasOfficeSelected = true }: ITopNavBarProps) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { totalInbox } = useInboxCount();

  const getHelp = () => {
    if (location.pathname === '/registration') {
      dispatch(
        showMessage({
          title: 'Error',
          message: 'Please finish your registration to access the rest of the platform.',
          isError: true,
        }),
      );
    } else {
      fireMenuBarHelpClicked();
      history.push(routes.help);
    }
  };

  const goToInbox = () => {
    if (location.pathname === '/registration') {
      dispatch(
        showMessage({
          title: 'Error',
          message: 'Please finish your registration to access the rest of the platform.',
          isError: true,
        }),
      );
    } else {
      fireMenuBarInboxClicked();
      history.push('/dashboard/inbox');
    }
  };

  const goToAccount = () => {
    fireMenuBarAccountClicked();
    history.push('/account');
  };

  const handleLogout = () => {
    sessionStorage.clear();
    dispatch(logOut());
  };

  return (
    <div style={{ height: NAVBAR_HEIGHT }}>
      <Navbar position="fixed">
        <Navbar.Brand>
          <Logo
            variant="light"
            height={44}
            style={{ cursor: 'pointer' }}
            onClick={() => history.push('/')}
          />
        </Navbar.Brand>

        {!location.pathname.includes('registration') && (
          <Navbar.Items>
            {hasOfficeSelected ? (
              <>
                <Navbar.Item
                  active={location.pathname === '/dashboard/inbox'}
                  onClick={goToInbox}
                  data-cy="top-nav-inbox-menu"
                >
                  Inbox
                  {totalInbox > 0 && (
                    <Badge
                      count={totalInbox}
                      maxCount={99}
                      variant="error"
                      size="sm"
                      style={{ marginLeft: 6, fontWeight: 'bold' }}
                    />
                  )}
                </Navbar.Item>
                <Navbar.Item
                  active={location.pathname === routes.help}
                  onClick={getHelp}
                  data-cy="top-nav-help-menu"
                >
                  Help
                </Navbar.Item>
                <Navbar.Item
                  active={location.pathname === '/account'}
                  onClick={goToAccount}
                  data-cy="top-nav-account-menu"
                >
                  Account
                </Navbar.Item>
              </>
            ) : (
              <Navbar.Item onClick={handleLogout} data-cy="top-nav-logout-menu">
                Log Out
              </Navbar.Item>
            )}
          </Navbar.Items>
        )}
      </Navbar>
    </div>
  );
}
